 
function SuccessBox(probs) {

    const transaction = probs.tx;
 
    return ( 
       <>
        <div className="timeline-content mb-3">
            <center>
                <i style={{fontSize:"40px",color:"var(--color-countdown-number)"}} class="fa-solid fa-circle-check"></i> <br/>
                    Purchase Successful<br/>  
                    <a style={{color:"var(--color-stage-title)",textDecoration:"none"}} target="_blank" href={"https://bscscan.com/tx/"+transaction}>View Explorer</a>
            </center>
        </div>
       </> 
 ); 

}

export default SuccessBox;